import { BrowserRouter, Route, Routes } from "react-router";
import { MainLayout } from "../layout";
import { LegacyDesktopLayout, LegacyMobileLayout } from "../layout/legacy";
import { HomePage } from "../pages/home";
import SmiNewsPage from "../pages/news/Smi/page";
import { useEffect } from "react";
import { useConfiguration } from "../hooks/useConfiguration";
import { Configuration } from "../types/common";
import SocialFeedPage from "../pages/news/SocialFeed/page";
import { CalendarPageApp, PlayersStatsPageApp, TournamentTablePageApp } from "./stats";
import MatchdayPage from "../pages/my/Matchday/page";
import Contests from "../pages/my/Contests/page";
import { MyTDesignPage } from "../pages/my/TDesign/page";
import MyAppPage from "../pages/my/MyApp/page";
import { PlayerProfilePageApp, TeamPlayersPageApp } from "./team";
import CoachesPage from "../pages/club/coaches/page";
import { Club100Page } from "../pages/club/club100/page";
import ManagementPage from "../pages/club/management/page";
import VacanciesListPage from "../pages/jobs/page";
import { StadiumPage } from "../pages/club/stadium";
import { PartnersPage } from "../pages/club/partners/page";
import { AboutClubPageApp } from "./club";
import { ExPlayersPage } from "../pages/club/ex-players/page";
import { PlayerProfilePage } from "../pages/player/page";
import MobileLayout from "../layout/MobileLayout";
import NewsPage from "../pages/news/List/page";
import { ContactsPage } from "../pages/club/contacts/page";
import NewsItemPage from "../pages/news/Item/page";

export const RootApp = () => {
    const config: Configuration = useConfiguration(true);
    config.standalone = true;

    return (
        <BrowserRouter>
            <MainLayout>
                <AppRoutes />
            </MainLayout>
        </BrowserRouter>
    );
}

const DefaultRoute = () => {
    useEffect(() => {
        const searchParams = new URLSearchParams(globalThis.location.search);
        if (searchParams.has("rr")) {
            return;
        }

        searchParams.append("rr", "1");

        globalThis.location.assign(window.location.pathname + "?" + searchParams.toString());
    }, []);

    return null;
}

export const AppRoutes = () => {
    return (
        <Routes>
            {/*<Route index element={<HomePage />} />*/}
            <Route path="/rodina" element={<HomePage />} />
            <Route path="/timeline" element={<SocialFeedPage />} />
            <Route path="/news/digest" element={<SmiNewsPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="news/:newsUrl" element={<NewsItemPage />} />

            <Route path="games" element={<CalendarPageApp />} />
            <Route path="games/tables" element={<TournamentTablePageApp />} />
            <Route path="tables" element={<TournamentTablePageApp />} />
            <Route path="games/stat/" element={<PlayersStatsPageApp />} />

            <Route path="/matchday" element={<MatchdayPage />} />
            <Route path="/goroda" element={<Contests />} />
            <Route path="/design" element={<MyTDesignPage />} />
            <Route path="/fan-app/" element={<MyAppPage />} />

            <Route path="team" element={<TeamPlayersPageApp />} />
            <Route path="team/ex-players" element={<ExPlayersPage />} />
            <Route path="team/players/:playerId" element={<PlayerProfilePageApp />} />
            <Route path="club/trainers" element={<CoachesPage />} />
            <Route path="/team/club-100" element={<Club100Page />} />

            <Route path="club" element={<AboutClubPageApp />} />
            <Route path="club/management" element={<ManagementPage />} />
            <Route path="jobs" element={<VacanciesListPage />} />
            <Route path="stadium" element={<StadiumPage />} />
            <Route path="partners" element={<PartnersPage />} />
            <Route path="club/contacts" element={<ContactsPage />} />

            <Route path="*" element={<DefaultRoute />} />
        </Routes>
    )
}